import React from 'react';
import useWindowDimensions from "../../../helpers/Hooks/useWindowDimensions";
const Container = ({ children }) => {
    const { height, width } = useWindowDimensions();
    const login_page_height = {
        height : height,
        width : width
    };
    return(
        <div className="login_page" style={login_page_height}>
            <div className="container">
                <div className="row">
                { children }
                </div> 
            </div>
        </div>
    )
};

export default Container;